// @ts-check
import { clone, keys, filter, find, findIndex, isEmpty, groupBy, forEach, mapObjIndexed, pipe, pluck, prop, propEq, reduce, sort, uniq, values, head } from 'ramda'
import moment from 'moment-timezone'
import manageReqsController from './manageReqs.ctrl'
import manageReqs from './manageReqs.html'
import manageDetailsController from './manageDetails.ctrl'
import manageDetails from './manageDetails.html'
import groupMessageController from '../workforce/message/groupMessage.ctrl.js'
import groupMessage from '../workforce/message/groupMessage.html'
import rosterOptions from './rosterOptions.html'
import reminderEmail from './reminderEmail.html'
import reminderEmailCtrl from './reminderEmail.ctrl'
import profileTemplate from '../workforce/worker/worker.html'
import { WorkerController } from '../workforce/worker/worker.controller'
import addWorkerCtrl from '../job/addWorker/addWorker.ctrl'
import addWorkerTpl from '../job/addWorker/addWorker.html'
import editScheduleCtrl from '../roster/edit-schedule/edit-schedule.ctrl'
import editScheduleTpl from '../roster/edit-schedule/edit-schedule.html'
import { addDays, differenceInCalendarDays, endOfWeek, isSunday, differenceInDays } from 'date-fns'

class ManageJobsController {
  /* @ngInject*/
  constructor (Auth, ManageJobs, ReferenceService, ToastService, Jobs, $scope, $templateCache, Message, Companies, Users, $stateParams, jobTypes, $mdDialog, $q, $interval, $mdSidenav, admins, skills, $mdExpansionPanel, $state) {
    this.ManageJobs = ManageJobs
    this.ToastService = ToastService
    this.Jobs = Jobs
    this.Users = Users
    this.Message = Message
    this.Companies = Companies
    this.$mdDialog = $mdDialog
    this.$mdExpansionPanel = $mdExpansionPanel
    this.$q = $q
    this.$interval = $interval
    this.$mdSidenav = $mdSidenav
    this.$templateCache = $templateCache
    this.$scope = $scope
    this.skills = skills
    this.$state = $state

    // internal tool so company id is 2
    this.company = { id: 2 }
    this.dateViewToggle = 'weeks'
    if ($stateParams) {
      this.region = $stateParams.region || null
      this.cancelledJobs = $stateParams.cancelled || false
      this.acctManager = $stateParams.manager || null
      this.openJobId = $stateParams.jobId || null
    }

    this.stateParams = $stateParams
    this.isTodaysDate = (date) => moment(date).isSame(this.now, 'day')
    this.calculateDaysFrom = (date) => {
      const currentTime = moment.tz(this.now, moment.tz.guess()).format('H:mm')
      const timeAndDate = moment(date + ' ' + currentTime)
      return moment(timeAndDate).fromNow()
    }

    this.jobTypes = jobTypes
    this.selectedDay
    this.allSelect = false
    this.anySelect = false

    this.region
    this.acctManager
    this.cancelledJobs = false
    this.regions = []
    this.acctManagers = admins

    this.sortBy = 'title'
    this.sortReverse = false

    this.groupByKey = 'company'
    this.hideDirectHire = false
    this.showOnlyDirectHire = false
    this.hideEndedJobs = true
    this.sortStartTime = false
    this.Auth = Auth

    this.selectedCity

    this.usersLoader = false

    this.query = { updateUsers: [] }
    this.expanded = {}

    /* will be eventially moved to DB */
    this.nationalAccountCondition = CONFIG.IS_PROD
    ? {
      parent_company_ids: [653, 664, 22],
      name_starts_with: ['bonappetit', 'lyft', 'grove']
    }
    // staging accounts designated National for testing
    : {
      parent_company_ids: [653, 2],
      name_starts_with: ['national']
    }


    ReferenceService.getRegions()
    .then(results => {
      this.regions = sort((a, b) => { return a.label > b.label ? 1 : -1 }, results)
      this.regions.unshift({label: 'All'})
      this.Auth.getDetails()
      .then(result => {
        // default to all regions if user region is not set
        this.region = result.region_id == null
          ? 'All'
          : find(propEq('id', result.region_id))(this.regions).label
        this.initialJobsLoad()
        this.getJobs(this.startDateOfWeek)
      })
    })

    this.getFeatureFlags()
  }

  initialJobsLoad () {
    if (this.stateParams.date) {
      this.dateCutoff = moment(this.stateParams.date).startOf(this.dateViewToggle).format()
      this.futureDateCutoff = moment(this.stateParams.date).endOf(this.dateViewToggle).format()
      this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
      this.todaysDate = this.stateParams.date
      this.startDateOfWeek = dateCutoff
    } else {
      this.isToday = true
      this.dateCutoff = moment(this.now).startOf(this.dateViewToggle).format()
      this.futureDateCutoff = moment(this.now).endOf(this.dateViewToggle).format()
      this.startDateOfWeek = this.dateCutoff
    }
  }

  toggleDate (toggle) {
    this.dateCutoff = moment(toggle).startOf(this.dateViewToggle).format()
    this.futureDateCutoff = moment(toggle).endOf(this.dateViewToggle).format()
    this.pdfRosterDate = moment(this.dateCutoff).format('YYYY-MM-DD')
    this.pdfRosterWeekEndDate = moment(this.dateCutoff).add(1, 'week').format('YYYY-MM-DD')
    this.$location.path('roster/' + this.pdfRosterDate).replace()
    this.isToday = moment(this.dateCutoff).isSame(this.now, 'day')
    this.getJobs()
  }
  
  getJobs () {
    this.loaded = false
    this.selectedDay = this.dateCutoff
    let startDateOfWeek = moment(this.startDateOfWeek)
    let queryDate = startDateOfWeek.startOf('day').toDate()

    let region = this.region === 'All' ? null : this.region
    this.ManageJobs.getManagedJobsV3(queryDate, region, false, this.cancelledJobs, this.accountManager)
      .then(data => {
        for (let jobId in data) {
          const companyNormalizedName = data[jobId].company_name.toLowerCase().replace(' ', '')

          data[jobId].nationalAccount = false

          if (this.nationalAccountCondition.parent_company_ids.includes(data[jobId].parent_company_id)) {
            data[jobId].nationalAccount = true
          } else {
            this.nationalAccountCondition.name_starts_with.forEach(text => {
              if (companyNormalizedName.startsWith(text)) {
                data[jobId].nationalAccount = true
              }
            })
          }
        }
        this.jobsForWeek = data
        this.group(this.jobsForWeek)
        if (this.openJobId) {
          // if you pass in Job Id Url Param, Open the job that was passed in
          let openPanel = find(propEq('job_id', parseInt(this.openJobId)))(data)
          if (openPanel) {
            this.openByCompany(openPanel.company_name)
          } else {
            this.ToastService.showWarning('Job not found.')
          }
        }
        this.loaded = true
        this.group(this.jobsForWeek, false)
      })
      .catch((error) => {
        console.log(error)
        return this.ToastService.showWarning('Unable to load jobs.')
      })
  }

  updateFilter (day = moment()) {
    this.startDateOfWeek = day
    this.selectedDay = day
    let startDateOfWeek = moment(this.startDateOfWeek)
    let queryDate = startDateOfWeek.startOf('day').toDate()

    this.ManageJobs.getManagedJobsV3(queryDate, this.region, false, this.cancelledJobs, this.accountManager)
      .then(data => {
        this.jobsForWeek = data
        this.group(this.jobsForWeek, false)
      })
      .catch((error) => {
        console.log(error)
        return this.ToastService.showWarning('Unable to load jobs.')
      })
  }

  calculateFillForJobs (allJobs) {
    //  filter out future start date jobs for weekly stats
    const jobs = filter(job => !this.dateIsAfterThisSunday(job.start_date_time), allJobs)
    const numberOfJobs = jobs.length
    const totalNeeded = reduce((a, b) => a + b.needed, 0, jobs)
    const totalOnJob = reduce((a, b) => a + b.filled || 0, 0, jobs)
    const unfilledJobs = reduce((a, b) => b.filled >= b.needed ? a + 1 : a, 0, jobs)
    const recentCancels = reduce((a, b) => a + b.recent_cancellations, 0, jobs)
    const currentlyFilling = reduce((a, b) => a + b.currentlyFilling, 0, jobs)

    let fillRate = Math.floor(totalOnJob / totalNeeded * 100)
    return {totalOnJob, totalNeeded, fillRate, unfilledJobs, numberOfJobs, recentCancels, currentlyFilling}
  }

  jobIsValid (job) {
    if (!job.attachedUsers && !job.invited_worker && !job.directHires) return false
    return true
  }

  filterByRegion () {
    const jobs = this.region === 'All' ? this.jobsForWeek : filter(x => x.region == this.region, this.jobsForWeek)
    this.$location.path('region/' + this.region).replace()
    this.group(jobs)
  }

  group (jobs, collapse = true) {
    if (collapse) {
      this.expanded = {}
    }

    let clonedJobs = clone(jobs)

    const groupByCompany = (job) => {
      return job.company_name
    }

    let groupByFunction = pipe(
      groupBy(groupByCompany),
      mapObjIndexed((jobs, company) => {
        let fill = this.calculateFillForJobs(jobs)
        return { title: company, fill, jobs }
      }),
      values
    )
    
    if (this.hideDirectHire) {
      clonedJobs = filter(job => !job.is_direct_hire, clonedJobs)
    }

    if (this.showOnlyDirectHire) {
      clonedJobs = filter(job => job.is_direct_hire, clonedJobs)
    }

    if (this.hideEndedJobs) {
      clonedJobs = filter(job => moment(job.end_date_time).diff(moment(this.selectedDay)) >= 0, clonedJobs)
    }

    if (this.nationalAccountsOnly) {
      clonedJobs = filter(job => job.nationalAccount, clonedJobs)
    }

    if (this.implementationMode) {
      clonedJobs = filter(job => job.company_in_implementation_mode, clonedJobs)
    }

    if (this.searchCompanyText) {
      clonedJobs = filter(job => job.company_name.toLowerCase().includes(this.searchCompanyText.toLowerCase()), clonedJobs)
    }

    if (this.searchJobId) {
      clonedJobs = filter(job => job.job_id.toString().includes(this.searchJobId), clonedJobs)
    }

    if (this.acctManager) {
      clonedJobs = filter(job => job.am_id === this.acctManager, clonedJobs)
    }
    let allJobs = groupByFunction(clonedJobs)
    this.totalStats = this.calculateFillForJobs(clonedJobs)
    this.groupedJobs = {allJobs}

    if (this.searchJobId && clonedJobs.length === 1) {
      this.expanded[this.groupedJobs.allJobs[0].title] = true
    }
  }

  isEmpty (obj) {
    return isEmpty(obj)
  }

  updateWage ($event, job) {
    let confirm = this.$mdDialog.prompt()
      .title('Update Wage & Repost')
      .ariaLabel('Wage')
      .targetEvent($event)
      .ok('Repost')
      .initialValue(job.wage)
      .cancel('Cancel')
    this.$mdDialog.show(confirm)
      .then(wage => {
        this.updateWageRepost(job, wage)
      }, this.updateWageError.bind(this))
  }

  updateWageRepost (job, newWage) {
    let billClient = this.$mdDialog.confirm()
      .title('Bill Client or Nahh?')
      .textContent('Do you want the client to be billed for this wage increase?')
      .ariaLabel('bill client')
      .ok('Bill Client')
      .cancel("Don't Bill")
    this.$mdDialog.show(billClient)
      .then(() => {
        this.ManageJobs.increaseWage({ jobId: job.job_id, newWage: newWage, clientApproved: true })
      })
      .catch(() => {
        this.ManageJobs.increaseWage({ jobId: job.job_id, newWage: newWage, clientApproved: false })
      })
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, {wage: newWage})
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to Modify Job Status')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(this.jobsForWeek, false)
        return this.ToastService.showSuccess('Successfully Increased Wage.')
      })
  }

  updateWageError () { }

  showRosterOptions ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      clickOutsideToClose: true,
      template: rosterOptions,

      controllerAs: 'ro',
      locals: { job, selectedDay: this.selectedDay },
      controller: class rosterOptionsCtrl {
        /* @ngInject*/
        constructor (ManageJobs, job, selectedDay, ToastService, $window) {
          this.ManageJobs = ManageJobs
          this.job = job
          this.selectedDay = selectedDay
          this.ToastService = ToastService
          this.$window = $window
        }

        downloadRosterCSV (job) {
          return this.ManageJobs.getRosterCSV(job)
            .then((res) => {
              let file = new Blob([res.data], {type: 'application/csv'})
              let fileName = job.company_name.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '-') + '-' + moment(job.start_date_time).format('YYYY-MM-DD')
              let fileURL = URL.createObjectURL(file)

              let a = document.createElement('a')
              a.href = fileURL
              a.target = '_blank'
              a.download = fileName + '.csv'
              document.body.appendChild(a)
              a.click()
            })
            .catch(() => {
              return this.ToastService.showWarning('Roster Not Available')
            })
        }

        downloadRosterPDF (day, job) {
          return this.ManageJobs.getRosterPDF(day, job)
            .then((res) => {
              let file = new Blob([res.data], {type: 'application/pdf'})
              let fileName = job.company_name.replace(/[^a-zA-Z ]/g, '').replace(/\s+/g, '-') + '-' + moment(job.start_date_time).format('YYYY-MM-DD')
              let fileURL = URL.createObjectURL(file)

              let a = document.createElement('a')
              a.href = fileURL
              a.target = '_blank'
              a.download = fileName + '.pdf'
              document.body.appendChild(a)
              a.click()
            })
            .catch(() => {
              return this.ToastService.showWarning('Roster Not Available')
            })
        }
      }
    })
  }

  showJobTimeline ($event, jobId) {
    this.ManageJobs.getJobTimeline({ jobId: jobId })
    .then(res => {
      let users = keys(res)
      let str = ''
      for (var j = 0; j < users.length; j++) {
        str += '<tr>'
        str += '<td>' + res[users[j]].name + '</td>'
        str += '<td>' + res[users[j]].applied_at + '</td>'
        str += '<td>' + res[users[j]].application_last_updated + '</td>'
        str += '<td>' + res[users[j]].application_status + '</td>'
        str += '<td>' + res[users[j]].confirm_time + '</td>'
        str += '<td>' + res[users[j]].confirm_status + '</td>'
        str += '<td>' + res[users[j]].confirm_updated_at + '</td>'
        str += '<td>' + res[users[j]].added_from_waitlist_time + '</td>'
        str += '<td>' + res[users[j]].added_from_waitlist_updated + '</td>'
        str += '<td>' + res[users[j]].waitlist_status + '</td>'
        str += '<td>' + res[users[j]].cancel_time + '</td>'
        str += '</tr>'
      }
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .multiple(true)
          .title('Job Accept Timeline')
          .htmlContent(`There are <strong> ${users.length}</strong> job accept / confirm / waitlist events <br>
          <table class="simple" cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th style="text-align:left">User</th>
                <th style="text-align:left">Applied</th>
                <th style="text-align:left">Last Updated</th>
                <th style="text-align:left">Status</th>
                <th style="text-align:left">Confirm</th>
                <th style="text-align:left">Confirm Sent</th>
                <th style="text-align:left">Confirm Updated</th>
                <th style="text-align:left">Pull Waitlist</th>
                <th style="text-align:left">Waitlist Status</th>
                <th style="text-align:left">Waitlist Respone</th>
                <th style="text-align:left">Cancel</th>
              </tr>
            </thead>
            <tbody>
              ${str}
              </tbody>
          </table>
          `)
          .ariaLabel('User Info')
          .ok('Close')
      )
    })
  }

  showEditSchedule (job, selectedShift) {
    let confirm = {
      controller: editScheduleCtrl,
      controllerAs: 'add',
      template: editScheduleTpl,
      fullscreen: true,
      scope: this.$scope,
      preserveScope: true,
      clickOutsideToClose: true,
      locals: {
        company: this.company,
        jobs: this.jobs,
        dates: this.shifts,
        //  remove
        job: job,
        Users: this.Users,
        shift: selectedShift,
        workforce: this.myWorkforce
      }
    }
    return this.$mdDialog.show(confirm)
      .then()
      .finally(() => {
        confirm = undefined
        return this.$mdDialog.hide()
      })
  }

  showManageDetails ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      fullscreen: true,
      clickOutsideToClose: true,
      template: manageDetails,
      locals: {
        job: job,
        manageJobs: this.ManageJobs,
        supervisors: this.Companies.fetchCompanyUsers(job.company_id)
      },
      controller: manageDetailsController,
      controllerAs: 'md',
      onRemoving: () => {
        this.$templateCache.remove(manageDetails)
      }
    })

      .then(({message, jobDetails}) => {
        if (!jobDetails) {
          return this.ToastService.showWarning(message)
        }
        let index = findIndex(x => x.job_id === job.job_id, this.jobsForWeek)
        for (let property in jobDetails) {
          if (jobDetails.hasOwnProperty(property)) {
            this.jobsForWeek[index][property] = jobDetails[property]
            this.jobsForWeek[index].updated = true
          }
        }
        const updated_job = this.jobsForWeek[index]
        this.groupedJobs.allJobs = this.groupedJobs.allJobs.map(company => {
          company.jobs = company.jobs.map(j => {
            return j.job_id === job.job_id ? updated_job : j
          })
          return company
        })
        return this.ToastService.showWarning(message)
      })
      .catch(() => {
        return this.ToastService.showSuccess('No Changes Made')
      })
  }

  showManageReqs ($event, job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: manageReqs,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        jobId: job.job_id,
        reqs: job.requirements,
        updateReqs: this.ManageJobs.updateReqs
      },
      controller: manageReqsController,
      controllerAs: 'mr'
    })
  }

  wholePlatform (job) {
    this.ManageJobs.wholePlatform({ jobId: job.external_id, wholePlatform: true })
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, { whole_platform: 1 })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to increase speed.')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(this.jobsForWeek, false)
        return this.ToastService.showSuccess('Successfully sent to whole platform.')
      })
  }

  updateNeededAndOverfill (job, needed, overfill) {
    if (job.needed !== needed && needed >= 0) this.updateNumberNeeded(job, needed)
    if (job.overfill !== overfill && overfill >= 0) this.updateOverfill(job, overfill)
  }

  updateNumberNeeded (job, newNumberNeeded) {
    this.ManageJobs.updateNumberNeeded(
      {
        jobId: job.external_id,
        needed: newNumberNeeded,
        prevNeeded: job.needed
      })
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, { needed: newNumberNeeded })
          .then((jobs) => {
            this.jobsForWeek = jobs
            this.group(this.jobsForWeek, false)
            return this.ToastService.showSuccess('Successfully updated number needed')
          })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to update Number Needed.')
      })
  }

  updateOverfill (job, overfill) {
    this.ManageJobs.updateOverfill(
      {
        jobId: job.external_id,
        overfill: overfill,
        prevOverfill: job.overfill
      })
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, { overfill: overfill })
          .then((jobs) => {
            this.jobsForWeek = jobs
            this.group(this.jobsForWeek, false)
            return this.ToastService.showSuccess('Successfully updated overfill')
          })
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to update Number Needed.')
      })
  }
  
  cancelJob (job) {
    const confirm = this.$mdDialog.confirm()
        .title('Cancel Job')
        .textContent('Are you sure you want to cancel?')
        .ariaLabel('Cancel Job')
        .ok('Yes')
        .cancel('No')
    this.$mdDialog.show(confirm)
        .then(() => {
          this.ManageJobs.cancelJob({ jobId: job.external_id})
              .then(() => {
                const jobs = this.ManageJobs.deleteJob(job.job_id)
                this.group(jobs, false)
                this.ToastService.showSuccess('Successfully canceled job.')
              })
              .catch(() => {
                this.ToastService.showWarning('Unable to cancel job.')
              })
        }, () => {})
  }

  showActionConfirm (callKey, data, successMessage = 'Action Successful', errMessage = 'Action Failed') {
    if (!callKey || !data) return

    this.ManageJobs[callKey](data)
      .then(() => this.ToastService.showSuccess(successMessage),
      () => this.ToastService.showWarning(errMessage))
  }

  toggleJobReminder (job) {
    let reminders = !job.reminders ? 1 : 0
    let data = { jobId: job.external_id, reminder: !job.reminders }
    this.ManageJobs.updateReminders(data)
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, 'reminders', reminders)
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to Modify Job Status')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(jobs, false)
        return this.ToastService.showSuccess('Successfully Toggled Job Reminders')
      })
  }

    /**
   * todo - split out this method into two parts
   * 1) wrapper for toggling job pause status
   * 2) generalized method for getting, filtering, and grouping jobs after a property is updated
   */
  pauseJob (job) {
    let pause = !job.paused
    let data = { jobId: job.external_id, pause }
    this.ManageJobs.pauseJob(data)
      .then(() => {
        return this.ManageJobs.setJobVal(job.job_id, {paused: pause})
      })
      .catch(() => {
        return this.ToastService.showWarning('Unable to Modify Job Status')
      })
      .then((jobs) => {
        this.jobsForWeek = jobs
        this.group(this.jobsForWeek, false)
        return this.ToastService.showSuccess('Toggled Job Pause Status')
      })
  }

  startNickAlgo (job) {
    this.ManageJobs.startNickAlgo({jobId: job.external_id})
      .then((res) => {
        this.$mdDialog.show(
          this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Job Dispatch')
            .content(res.data)
            .ariaLabel('Start Dispatch')
            .ok('Close')
        )
        // let currentlyFilling = !job.currentlyFilling
      })
      .catch((error) => {
        this.$mdDialog.show(
          this.$mdDialog.alert()
            .clickOutsideToClose(true)
            .title('Job Dispatch')
            .content(error.data)
            .ariaLabel('Start Dispatch Error')
            .ok('Close')
        )
      })
  }

  confirmRosterChanges (job) {
    const jobStatuses = {
      'success': 0,
      'waitlist': 1,
      'removed': 8
    }

    mapObjIndexed((workersInBucket, statusName) => {
      forEach(worker => {
        const status = jobStatuses[statusName]
        if (worker.status !== status) {
          worker.status = status
          this.query.updateUsers.push({
            status: status,
            jobId: job.external_id,
            userId: worker.external_id
          })
        }
      }, workersInBucket)
    }, {success: this.success, waitlist: this.waitlist, removed: this.removed})

    if (this.query.updateUsers.length === 0) {
      return this.ToastService.showWarning('No Workers Changed. Please Change Worker Status to Continue!')
    }

    const confirm = this.$mdDialog.confirm({
      title: 'Change Worker Roster',
      ok: 'Submit',
      cancel: 'Cancel'
    })

    return this.$mdDialog.show(confirm)
      .then(() => {
        return this.ManageJobs.updateJob(this.query)
          .then(() => this.Jobs.getJobAttachedUsers([job.external_id]))
          .then(updatedUsers => {
            this.query.updateUsers = []
            let changedRoster = updatedUsers[job.job_id]
            return this.ManageJobs.setJobVal(job.job_id, changedRoster)
            .then((jobs) => {
              this.ToastService.showSuccess('Worker Roster Updated.')
              return this.$mdDialog.hide()
            })
          })
      })
      .catch(() => {
        this.$mdDialog.hide()
        return this.ToastService.showWarning('Canceled roster update.')
      })
  }

  // Manage workers expansion panels
  showManageWorkers (job) {
    // const enums = {
    //   0: 'success',
    //   1: 'waitlist',
    //   8: 'removed'
    // }

    this.usersLoader = true
    // this.$mdExpansionPanel(parseInt(job.job_id)).expand()
    // this.$mdExpansionPanel().waitFor(this.openJobId).then(function (instance) {
    //   instance.expand()
    // })
    this.Jobs.getJobAttachedUsers([job.external_id])
      .then(workerList => {
        let workerData = head(values(workerList))
        this.getRoster(workerData.attachedUsers, job.job_id).then(roster => {
          this.roster = roster
          this.success = filter(worker => { return worker.status === 0 }, this.roster) || []
          this.waitlist = filter(worker => { return worker.status === 1 }, this.roster) || []
          this.directHires = job.directHires || job.crewPost || []
          this.removed = filter(worker => { return worker.status === 8 }, this.roster) || []
          this.selectedWorker
          this.note
          this.selected = null
          this.query = { updateUsers: [] }
          this.usersLoader = false
        })
      })
  }

  jobHasWorkers (job) {
    return job.attachedUsers || job.directHires || job.invited_worker_external_id
  }

  showReminderEmails (job) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      // targetEvent: $event,
      clickOutsideToClose: true,
      template: reminderEmail,
      controllerAs: 're',
      multiple: true,
      locals: { job: this.job },
      controller: reminderEmailCtrl
    })
  }

  updateWorkerError (err) {
    if (!err) return
    this.ToastService.showWarning('Unable to update worker statuses.')
  }

  viewProfile (id) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      template: profileTemplate,
      clickOutsideToClose: true,
      scope: this.$scope,
      preserveScope: true,
      locals: {
        worker: this.Users.getProfile(id),
        notes: this.Users.getNotes(id),
        application: this.Users.fetchApplication(id),
        jobTypes: this.jobTypes,
        skills: this.Users.getSkills(id),
        company: this.company,
        inModal: true
      },
      fullscreen: true,
      controller: WorkerController,
      controllerAs: 'w',
      onRemoving: () => {
        this.$templateCache.remove(profileTemplate)
      }
    })
  }

  showGroupMessage ($event, users) {
    const parentEl = document.body
    let userIds = pluck('external_id', users)
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: groupMessage,
      locals: {
        users: userIds
      },
      controller: groupMessageController,
      controllerAs: 'gm'
    })
  }

  singleMessage ($event, workerId) {
    const parentEl = document.body
    return this.$mdDialog.show({
      parent: parentEl,
      targetEvent: $event,
      template: groupMessage,
      locals: {
        users: [workerId]
      },
      controller: groupMessageController,
      controllerAs: 'gm'
    })
  }

  getAdminIntercom (adminEmail) {
    this.singleUserMessagesLoading = true
    this.Message.getAdminConversations(adminEmail)
    .then((conv) => {
      this.intercomMessages = conv.body.conversations
      this.singleUserMessagesLoading = false
    })
  }

  showAddWorker (job) {
    let confirm = {
      controller: addWorkerCtrl,
      controllerAs: 'add',
      template: addWorkerTpl,
      fullscreen: true,
      clickOutsideToClose: true,
      locals: {
        Users: this.Users,
        job,
        shift: null
      }
    }

    return this.$mdDialog.show(confirm)
      .then(
        worker => {
          this.roster.push(worker)
          this.success.push(worker)
          this.$mdDialog.hide()
          return this.$mdToast.showSimple('Worker Roster Updated.')
        },
        () => {
          this.$mdDialog.hide()
          return this.$mdToast.showSimple('Cancelled Add Worker')
        }
      )
  }

  openByCompany (companyName) {
    this.expanded[companyName] = true
    // this.$mdExpansionPanel(parseInt(this.openJobId)).expand()
    this.$mdExpansionPanel().waitFor(this.openJobId).then(function (instance) {
      instance.expand()
    })
    this.openJobId = null
  }

  jobPulse (jobId) {
    this.Jobs.jobPulse(jobId)
    .then(res => {
      let users = keys(res)
      let numOverlapping = 0
      let str = ''
      for (var j = 0; j < users.length; j++) {
        var overlapping_company = ''
        if (res[users[j]].overlapping_company) { overlapping_company = res[users[j]].overlapping_company; numOverlapping++ }
        res[users[j]].overlapping_company
        str += '<tr>'
        str += '<td>' + res[users[j]].name + '</td>'
        str += '<td>' + res[users[j]].shifts_worked + '</td>'
        str += '<td>' + new Date(res[users[j]].last_shift).toDateString() + '</td>'
        str += '<td>' + res[users[j]].companies.toString() + '</td>'
        str += '<td>' + overlapping_company + '</td>'
      }
      this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .multiple(true)
          .title('Recently Active Workers')
          .htmlContent(`There are <strong> ${users.length}</strong> active users within 10 miles of this job in the past 15 days. <br>
          <strong>${numOverlapping}</strong> users are working other jobs <br>
          <table class="simple" cellpadding="0" cellspacing="0" border="0">
            <thead>
              <tr>
                <th style="text-align:left">Name</th>
                <th style="text-align:left">shifts worked</th>
                <th style="text-align:left">last shift</th>
                <th style="text-align:left">companies</th>
                <th style="text-align:left">overlaping</th>
              </tr>
            </thead>
            <tbody>
              ${str}
              </tbody>
          </table>
          `)
          .ariaLabel('User Info')
          .ok('Close')
      )
    })
  }

  dateIsAfterThisSunday (date) {
    const today = new Date()
    let thisSunday
    if (isSunday(today)) {
      thisSunday = today
    } else {
      const endOfWeekDate = endOfWeek(today)
      thisSunday = addDays(endOfWeekDate, 1)
    }

    return differenceInCalendarDays(date, thisSunday) > 0
  }

  getRoster (users, jobId) {
    return new Promise((resolve, reject) => {
      if (users.length === 0) {
        resolve(users)
        return
      }
      const userIds = users.map(user => user.id)
      Promise.all([
        this.Users.getPerformanceData(userIds),
        this.Users.getPerformanceScore(userIds, jobId)
      ]).then(result => {
        const roster = users.map(user => {
          return {
            ...user,
            ...result[0][user.id],
            ...result[1][user.id]
          }
        })
        resolve(roster)
      })
    })
  }

  getFeatureFlags () {
    this.Auth.splitClient.ready().then(() => {
      const reliabilityScoreKey = 'reliability_score'
      const overfillKey = 'Overfill-BCTOOLS-980'

      const treatments = this.Auth.splitClient.getTreatments([reliabilityScoreKey, overfillKey])

      this.showReliabilityScore = treatments[reliabilityScoreKey] === 'on'
      if (treatments[overfillKey] === 'edit') {
        this.showOverfill = true
        this.candEditOverfill = true
      } else if (treatments[overfillKey] === 'view') {
        this.showOverfill = true
        this.candEditOverfill = false
      } else {
        this.showOverfill = false
        this.candEditOverfill = false
      }
    }).catch(() => {
      console.log('Error Initializing Split.io')
    })
  }
}

export default ManageJobsController
